import React from 'react';
import Logo from '../assets/Logo';

function Header() {
  return (
    <header className="header">
      <Logo />
      <h2 className="header__title">Wisdom Pet Medicine</h2>
    </header>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/ui/Header.jsx